import { subPlanType } from '../../hooks/useIdcw';
import { IsAllow } from './portfolio';

export const FETCH_FUND_TRANSACTION_DETAILS = 'FETCH_FUND_TRANSACTION_DETAILS';
export const FETCH_FUND_TRANSACTION_DETAILS_SUCCESS = 'FETCH_FUND_TRANSACTION_DETAIL_SUCCESS';

export const GET_INVESTOR_LATEST_DETAILS = 'GET_INVESTOR_LATEST_DETAILS';
export const GET_INVESTOR_LATEST_DETAILS_SUCCESS = 'GET_INVESTOR_LATEST_DETAILS_SUCCESS';
export const GET_INVESTOR_LATEST_DETAILS_FAILED = 'GET_INVESTOR_LATEST_DETAILS_FAILED';

export const REDEEM_SCHEME = 'REDEEM_SCHEME';
export const REDEEM_SCHEME_SUCCESS = 'REDEEM_SCHEME_SUCCESS';
export const SWITCH_SCHEME = 'SWITCH_SCHEME';
export const SWITCH_SCHEME_SUCCESS = 'SWITCH_SCHEME_SUCCESS';
export const RTA_SCHEME_DETAIL_SUCCESS = 'RTA_SCHEME_DETAIL_SUCCESS';
export const SAVE_CHEQUE_FILE = 'SAVE_CHEQUE_FILE';


export const STP_TRANSACTION_SUCCESS = 'STP_TRANSACTION_SUCCESS';
export const STP_TRANSACTION = 'STP_TRANSACTION';

export const SIP_SUMMARY = 'SIP_SUMMARY';
export const SIP_SUMMARY_SUCCESS = 'SIP_SUMMARY_SUCCESS';

export const SIP_VALIDATION = 'SIP_VALIDATION';
export const SIP_VALIDATION_SUCCESS = 'SIP_VALIDATION_SUCCESS';

export const SIP_SUBMIT = 'SIP_SUBMIT';
export const SIP_SUBMIT_SUCCESS = 'SIP_SUBMIT_SUCCESS';
export const OTM_CANCEL_API = 'OTM_CANCEL_API';
export const OTM_CANCEL_API_SUCCESS = 'OTM_CANCEL_API_SUCCESS';

export const SIP_TRANSACTION = 'SIP_TRANSACTION';
export const SIP_TRANSACTION_SUCCESS = 'SIP_TRANSACTION_SUCCESS';

export type AmountType = {
    minAmount: number | string;
    maxAmount: number | string;
    multiples: number | string;
};

export type _schemeDetailsNewType = {
    commonDetails: {
        amc: string;
        amcName: string;
        isin: string;
        schemeName: string;
        activeFlag: IsAllow;
        purAllow: IsAllow;
        redAllow: IsAllow;
        swiAllow: IsAllow;
        sipAllow: IsAllow;
        stpAllow: IsAllow;
        swpAllow: IsAllow;
        planMode: string;
        isDividend: string;
    };
    freshPurchase: AmountType;
    additionalPurchase: AmountType;
    redemption: AmountType;
    switch: AmountType;
    sip: sipType;
    swp: sipType;
    stp: sipType;
    subPlans: Array<subPlanType>;
};

export type schemeDetailsNewType = [
    {
        amc: string;
        amcName: string;
        isin: string;
        schemeName: string;
        activeFlag: 'Y' | 'N';
        purAllow: 'Y' | 'N';
        redAllow: 'Y' | 'N';
        swiAllow: 'Y' | 'N';
        sipAllow: 'Y' | 'N';
        stpAllow: 'Y' | 'N';
        swpAllow: 'Y' | 'N';
        planMode: string;
        isDividend: string;
    },
    {
        freshPurchase: AmountType;
    },
    {
        additionalPurchase: AmountType;
    },
    {
        redemption: AmountType;
    },
    {
        switch: AmountType;
    },
    {
        sip: sipType;
    },
    {
        stp: sipType;
    },
    {
        swp: sipType;
    },
    {
        subPlans: Array<subPlanType>;
    },
];

export type schemeDetailsResponseType = {
    body: {
        data: schemeDetailsNewType;
    };
};

type individualSipType = {
    multiples: number | string;
    minSipTat: number | string;
    maxSipTat: number | string;
    dates: Array<string>;
    minimumInstallments: Array<{
        installment: number | string;
        minAmount: number | string;
        maxAmount: number | string;
    }>;
};
type individualStpType = Pick<individualSipType, 'minimumInstallments' | 'multiples' | 'dates'>;

export type sipType = {
    [key: string]: individualSipType | undefined;
    Annual?: individualSipType;
    Weekly?: individualSipType;
    Daily?: individualSipType;
    Yearly?: individualSipType;
    'Half-Yearly'?: individualSipType;
    Fortnightly?: individualSipType;
    Quarterly?: individualSipType;
    Monthly?: individualSipType;
};

export enum schemeDetailArrayIndices {
    commonDetails = 0,
    freshPurchase = 1,
    additionalPurchase = 2,
    redemption = 3,
    switch = 4,
    sip = 5,
    stp = 6,
    swp = 7,
    subPlans = 8,
}

export const defalutSipData: Partial<sipType> = {
    Monthly: {
        dates: [],
        maxSipTat: '',
        minSipTat: '',
        multiples: '',
        minimumInstallments: [
            {
                installment: '',
                maxAmount: '',
                minAmount: '',
            },
        ],
    },
    Daily: {
        dates: [],
        maxSipTat: '',
        minSipTat: '',
        multiples: '',
        minimumInstallments: [
            {
                installment: '',
                maxAmount: '',
                minAmount: '',
            },
        ],
    },
};

export type schemeDetailsRequestType = {
    isin: string;
    amcCode: string;
};
